module.exports = __webpack_public_path__ + "c23862468cdcd8b0f2836846f6259bf0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/campbell_soup_2022_chart.png
// module id = 1646
// module chunks = 0